/* ============================================================
   Patriot Tractor — theme.js
   Hamburger nav, quote modal, confirmation toast.
   No framework; progressive-enhancement only.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // close menu on link tap
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) menu.classList.remove('is-open');
    });

    // close when resizing up to desktop
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 880) menu.classList.remove('is-open');
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer = null;
  function showToast(message) {
    var toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.querySelector('[data-toast-msg]').textContent = message;
    toast.classList.add('is-visible');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 6000);
  }
  function hideToast() {
    var toast = document.querySelector('[data-toast]');
    if (toast) toast.classList.remove('is-visible');
  }
  function initToast() {
    var closeBtn = document.querySelector('[data-toast-close]');
    if (closeBtn) closeBtn.addEventListener('click', hideToast);

    // If a form posted successfully, Shopify reloads with ?contact_posted=true
    // or ?customer_posted=true — surface the toast on return.
    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') === 'true' || params.get('customer_posted') === 'true') {
      showToast(toast_success_message());
    }
  }
  function toast_success_message() {
    var el = document.querySelector('[data-toast]');
    return (el && el.getAttribute('data-success')) || "Thanks — we'll be in touch within one business day.";
  }

  /* ---------- Quote modal ---------- */
  function initQuote() {
    var modal = document.querySelector('[data-quote-modal]');
    if (!modal) return;
    var titleEl = modal.querySelector('[data-quote-title]');
    var productField = modal.querySelector('[data-quote-product]');

    function open(name) {
      if (titleEl) titleEl.textContent = name || '';
      if (productField) productField.value = name || '';
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var firstInput = modal.querySelector('input, textarea');
      if (firstInput) firstInput.focus();
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // delegate: any element with [data-quote-open] opens, passing its product name
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quote-open]');
      if (trigger) {
        e.preventDefault();
        open(trigger.getAttribute('data-quote-open'));
        return;
      }
      if (e.target.closest('[data-quote-close]')) { close(); return; }
      if (e.target === modal) close(); // backdrop click
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    // intercept submit -> show toast (until TargetWeb endpoint is wired in)
    var form = modal.querySelector('form');
    if (form && modal.getAttribute('data-quote-ajax') === 'true') {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = 'there';
        var nameField = form.querySelector('[name="quote-name"]');
        if (nameField && nameField.value.trim()) name = nameField.value.trim().split(' ')[0];
        form.reset();
        close();
        var tmpl = modal.getAttribute('data-success') || "Thanks, {name} — we'll be in touch within one business day.";
        // locale string uses {{ name }}; support both that and {name}
        showToast(tmpl.replace('{{ name }}', name).replace('{name}', name));
      });
    }
  }

  /* ---------- Product gallery (thumbnail swap + click-to-zoom) ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    var mainWrap = gallery.querySelector('[data-gallery-main]');
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    if (!mainWrap || !mainImg) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var currentIndex = 0;

    // Shared by thumbnail clicks and the lightbox arrows so the main
    // image, the zoom source, and the open lightbox all stay in sync.
    function showIndex(idx) {
      if (!thumbs.length) return;
      idx = (idx + thumbs.length) % thumbs.length;
      var thumb = thumbs[idx];
      var full = thumb.getAttribute('data-full');
      var zoom = thumb.getAttribute('data-zoom');
      var thumbImg = thumb.querySelector('img');
      if (full) { mainImg.src = full; mainImg.removeAttribute('srcset'); }
      if (zoom) { mainWrap.setAttribute('data-zoom-src', zoom); }
      currentIndex = idx;
      updateZoomImage(zoom, thumbImg ? thumbImg.alt : '');
    }

    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var idx = thumbs.indexOf(thumb);
      if (idx !== -1) showIndex(idx);
    });

    // Click (or Enter/Space) the main image to open the zoom lightbox.
    mainWrap.addEventListener('click', function () { openImageZoom(mainWrap); });
    mainWrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openImageZoom(mainWrap);
      }
    });

    // Expose stepping so the lightbox's prev/next arrows can drive it.
    gallery._ptZoomNext = function () { showIndex(currentIndex + 1); };
    gallery._ptZoomPrev = function () { showIndex(currentIndex - 1); };
  }

  /* ---------- Image zoom lightbox ---------- */
  var imageZoomOpener = null;
  function updateZoomImage(src, alt) {
    var modal = document.querySelector('[data-image-modal]');
    if (!modal || !modal.classList.contains('is-open') || !src) return;
    var img = modal.querySelector('[data-image-modal-img]');
    if (img) { img.src = src; img.alt = alt || ''; }
  }
  function openImageZoom(trigger) {
    var modal = document.querySelector('[data-image-modal]');
    var src = trigger.getAttribute('data-zoom-src');
    if (!modal || !src) return;
    var img = modal.querySelector('[data-image-modal-img]');
    var triggerImg = trigger.querySelector('img');
    img.src = src;
    img.alt = triggerImg ? triggerImg.alt : '';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    imageZoomOpener = trigger;
  }
  function closeImageZoom() {
    var modal = document.querySelector('[data-image-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (imageZoomOpener) { imageZoomOpener.focus(); imageZoomOpener = null; }
  }
  function initImageZoom() {
    var modal = document.querySelector('[data-image-modal]');
    if (!modal) return;
    var gallery = document.querySelector('[data-product-gallery]');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-image-modal-close]') || e.target === modal) { closeImageZoom(); return; }
      if (e.target.closest('[data-image-modal-next]')) { if (gallery && gallery._ptZoomNext) gallery._ptZoomNext(); return; }
      if (e.target.closest('[data-image-modal-prev]')) { if (gallery && gallery._ptZoomPrev) gallery._ptZoomPrev(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeImageZoom(); return; }
      if (e.key === 'ArrowRight' && gallery && gallery._ptZoomNext) gallery._ptZoomNext();
      if (e.key === 'ArrowLeft' && gallery && gallery._ptZoomPrev) gallery._ptZoomPrev();
    });
  }

  /* ---------- Variant select (price refresh, single-section) ---------- */
  function initVariant() {
    var select = document.querySelector('[data-variant-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      // The option text carries the formatted price after the "· " separator.
      var opt = select.options[select.selectedIndex];
      var priceEl = document.querySelector('[data-product-price]');
      if (opt && priceEl && opt.text.indexOf('·') !== -1) {
        priceEl.textContent = opt.text.split('·').pop().trim();
      }
      // Keep the stock line and quantity cap in sync with the chosen variant.
      if (!opt) return;
      var qty = parseInt(opt.getAttribute('data-qty'), 10);
      var capped = opt.getAttribute('data-capped') === 'true';
      var input = document.querySelector('[data-qty-input]');
      var line = document.querySelector('[data-stock-line]');
      var text = document.querySelector('[data-stock-text]');

      if (input) {
        if (capped && !isNaN(qty)) {
          input.setAttribute('max', qty);
          if (parseInt(input.value, 10) > qty) input.value = qty > 0 ? qty : 1;
        } else {
          input.removeAttribute('max');
        }
      }
      if (line && text && !isNaN(qty)) {
        if (qty > 0) {
          line.hidden = false;
          line.classList.toggle('stock-line--low', qty <= 2);
          text.textContent = qty <= 2 ? 'Only ' + qty + ' left in stock' : qty + ' in stock';
        } else {
          line.hidden = true;
        }
      }
    });
  }

  /* ---------- Quantity cap (never let a customer request more than stock) ---------- */
  function initQtyLimit() {
    var input = document.querySelector('[data-qty-input]');
    if (!input) return;
    var warning = document.querySelector('[data-qty-warning]');

    function clamp() {
      var max = parseInt(input.getAttribute('max'), 10);
      var val = parseInt(input.value, 10);
      if (isNaN(max)) { if (warning) warning.hidden = true; return; }
      if (!isNaN(val) && val > max) {
        input.value = max;
        if (warning) {
          warning.textContent = max === 1
            ? 'Only 1 available — we have just one in stock.'
            : 'Only ' + max + ' available — that\'s all we have in stock.';
          warning.hidden = false;
        }
      } else if (warning) {
        warning.hidden = true;
      }
    }

    input.addEventListener('input', clamp);
    input.addEventListener('change', clamp);
    // Final guard: clamp on submit so a pasted/scripted value can't slip past.
    var form = input.closest('form');
    if (form) form.addEventListener('submit', clamp);
  }

  /* ---------- Product recommendations (async fetch + swap) ---------- */
  function initRecommendations() {
    var wrapper = document.querySelector('[data-product-recommendations]');
    if (!wrapper) return;
    var url = wrapper.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var fresh = html.querySelector('[data-product-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          wrapper.innerHTML = fresh.innerHTML;
          // Swapped-in cards carry their own compare checkboxes — the initial
          // checked-state sync already ran before this fetch resolved, so
          // re-run it now or a card already in the tray would render unchecked.
          compareSyncChecks(wrapper);
        }
      })
      .catch(function () { /* recommendations are non-critical */ });
  }

  /* ---------- Compare (tray + compare page) ---------- */
  // The selection is shopping-visit scoped: it follows the shopper from page
  // to page (and across tabs) while they browse, but expires after
  // COMPARE_TTL_MS of inactivity so a returning visitor starts clean instead
  // of being greeted by last week's compare tray. Stored as
  // { items: [...], ts: <last activity ms> }; every page load and every
  // change refreshes ts.
  var COMPARE_KEY = 'patriot_compare';
  var COMPARE_MAX = 4;
  var COMPARE_TTL_MS = 30 * 60 * 1000; // 30 minutes of inactivity
  var compareWarningTimer = null;

  function compareRead() {
    try {
      var data = JSON.parse(localStorage.getItem(COMPARE_KEY));
      // Older builds stored a bare array with no timestamp — its age is
      // unknown, so treat it as expired rather than resurrecting it forever.
      if (!data || Array.isArray(data) || !Array.isArray(data.items) ||
          typeof data.ts !== 'number' || Date.now() - data.ts > COMPARE_TTL_MS) {
        if (data !== null) localStorage.removeItem(COMPARE_KEY);
        return [];
      }
      return data.items;
    } catch (e) {
      return [];
    }
  }
  function compareWrite(items) {
    try {
      if (items.length) {
        localStorage.setItem(COMPARE_KEY, JSON.stringify({ items: items, ts: Date.now() }));
      } else {
        localStorage.removeItem(COMPARE_KEY);
      }
    } catch (e) { /* storage full/blocked — no-op, tray just won't persist */ }
  }
  // Browsing counts as activity: re-save to push the expiry forward.
  function compareTouch() {
    var items = compareRead();
    if (items.length) compareWrite(items);
  }
  // Re-render everything compare-related from storage.
  function compareRefreshAll() {
    compareRenderTray();
    compareSyncChecks();
    var compareRoot = document.querySelector('[data-compare-root]');
    if (compareRoot && compareRoot._ptCompareReload) compareRoot._ptCompareReload();
  }
  function compareFindIndex(items, handle) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) return i;
    }
    return -1;
  }
  function compareAdd(item) {
    var items = compareRead();
    if (compareFindIndex(items, item.handle) !== -1) return true; // already in tray
    if (items.length >= COMPARE_MAX) return false;
    items.push(item);
    compareWrite(items);
    return true;
  }
  function compareRemove(handle) {
    var items = compareRead();
    var idx = compareFindIndex(items, handle);
    if (idx !== -1) {
      items.splice(idx, 1);
      compareWrite(items);
    }
  }
  // Sets .checked on every compare checkbox in scope to match localStorage.
  // Runs on load and after anything swaps new checkboxes into the page.
  function compareSyncChecks(scope) {
    var root = scope || document;
    var items = compareRead();
    var boxes = root.querySelectorAll('[data-compare-check]');
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].checked = compareFindIndex(items, boxes[i].getAttribute('data-compare-handle')) !== -1;
    }
  }
  function compareShowCapWarning() {
    var tray = document.querySelector('[data-compare-tray]');
    var warning = tray && tray.querySelector('[data-compare-tray-warning]');
    if (!warning) return;
    warning.textContent = tray.getAttribute('data-cap-reached') || 'You can compare up to 4 machines at a time — remove one to add another.';
    warning.hidden = false;
    clearTimeout(compareWarningTimer);
    compareWarningTimer = setTimeout(function () { warning.hidden = true; }, 5000);
  }
  function compareRenderTray() {
    var tray = document.querySelector('[data-compare-tray]');
    if (!tray) return;
    var items = compareRead();
    var itemsWrap = tray.querySelector('[data-compare-tray-items]');
    var countEl = tray.querySelector('[data-compare-tray-count]');
    var removeTmpl = tray.getAttribute('data-remove-template') || 'Remove {{ title }} from compare';
    var countTmpl = tray.getAttribute('data-count-template') || '{{ count }} selected';

    if (itemsWrap) {
      itemsWrap.innerHTML = '';
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var chip = document.createElement('div');
        chip.className = 'compare-tray__item';
        chip.setAttribute('data-compare-handle', item.handle);

        var img = document.createElement('img');
        img.className = 'compare-tray__item-img';
        if (item.image) { img.src = item.image; img.alt = ''; }
        chip.appendChild(img);

        var title = document.createElement('span');
        title.className = 'compare-tray__item-title';
        title.textContent = item.title || '';
        chip.appendChild(title);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'compare-tray__item-remove';
        removeBtn.setAttribute('data-compare-remove', '');
        removeBtn.setAttribute('data-compare-handle', item.handle);
        removeBtn.setAttribute('aria-label', removeTmpl.replace('{{ title }}', item.title || '').replace('{title}', item.title || ''));
        removeBtn.innerHTML = '&times;';
        chip.appendChild(removeBtn);

        itemsWrap.appendChild(chip);
      }
    }

    if (countEl) {
      countEl.textContent = items.length ? countTmpl.replace('{{ count }}', items.length).replace('{count}', items.length) : '';
    }

    tray.classList.toggle('is-visible', items.length > 0);
    tray.setAttribute('aria-hidden', items.length > 0 ? 'false' : 'true');
  }

  function initCompare() {
    var tray = document.querySelector('[data-compare-tray]');
    if (!tray) return;

    document.addEventListener('change', function (e) {
      var check = e.target.closest('[data-compare-check]');
      if (!check) return;
      if (check.checked) {
        var added = compareAdd({
          handle: check.getAttribute('data-compare-handle'),
          title: check.getAttribute('data-compare-title'),
          image: check.getAttribute('data-compare-image'),
          url: check.getAttribute('data-compare-url')
        });
        if (!added) {
          check.checked = false;
          compareShowCapWarning();
          return;
        }
      } else {
        compareRemove(check.getAttribute('data-compare-handle'));
      }
      compareRenderTray();
    });

    // Shared by the tray's own remove/clear controls AND the compare page's
    // per-column remove buttons (same [data-compare-remove] attribute).
    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-compare-remove]');
      var clearBtn = e.target.closest('[data-compare-clear]');
      if (!removeBtn && !clearBtn) return;

      if (removeBtn) {
        compareRemove(removeBtn.getAttribute('data-compare-handle'));
      } else {
        compareWrite([]);
      }
      // Also re-renders the compare page's table if present (it stashes a
      // reload hook on itself — see initCompareTable).
      compareRefreshAll();
    });

    // Another tab added/removed a machine — mirror it here.
    window.addEventListener('storage', function (e) {
      if (e.key === COMPARE_KEY || e.key === null) compareRefreshAll();
    });
    // Back/forward navigation can restore this page from the browser's
    // page cache without re-running DOMContentLoaded, which would show the
    // tray as it was when the shopper left. Re-sync from storage.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { compareTouch(); compareRefreshAll(); }
    });

    compareTouch();
    compareRenderTray();
    compareSyncChecks();
  }

  /* ---------- Compare table (compare page only) ---------- */
  function compareBuildTable(products, rowConfig, table, promptEl, browseUrl) {
    if (!table) return;
    table.innerHTML = '';
    var canAddMore = products.length < COMPARE_MAX;
    if (promptEl) promptEl.hidden = products.length !== 1;

    var thead = document.createElement('thead');
    var headRow = document.createElement('tr');
    headRow.appendChild(document.createElement('th')); // corner cell, above row labels

    var p, product, th;
    for (p = 0; p < products.length; p++) {
      product = products[p];
      th = document.createElement('th');
      th.className = 'compare-table__col-head';

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'compare-table__col-remove';
      removeBtn.setAttribute('data-compare-remove', '');
      removeBtn.setAttribute('data-compare-handle', product.handle);
      removeBtn.setAttribute('aria-label', 'Remove ' + (product.title || '') + ' from compare');
      removeBtn.innerHTML = '&times;';
      th.appendChild(removeBtn);

      if (product.image) {
        var img = document.createElement('img');
        img.className = 'compare-table__col-img';
        img.src = product.image;
        img.alt = '';
        th.appendChild(img);
      }

      var link = document.createElement('a');
      link.className = 'compare-table__col-title';
      link.href = product.url;
      link.textContent = product.title || '';
      th.appendChild(link);

      var price = document.createElement('div');
      price.className = 'compare-table__col-price';
      price.textContent = product.price || '';
      th.appendChild(price);

      headRow.appendChild(th);
    }

    if (canAddMore) {
      var addTh = document.createElement('th');
      addTh.className = 'compare-table__col-add';
      var addLink = document.createElement('a');
      addLink.href = browseUrl || '/collections/all';
      addLink.setAttribute('aria-label', 'Add another machine to compare');
      addLink.innerHTML = '<span aria-hidden="true" style="display:block; font-size:28px; line-height:1;">+</span>Add Equipment';
      addTh.appendChild(addLink);
      headRow.appendChild(addTh);
    }

    thead.appendChild(headRow);
    table.appendChild(thead);

    var tbody = document.createElement('tbody');
    var r, row, pi, raw, hasAny, values;
    for (r = 0; r < rowConfig.length; r++) {
      row = rowConfig[r];
      if (!row || !row.key) continue;

      hasAny = false;
      values = [];
      for (pi = 0; pi < products.length; pi++) {
        raw = products[pi].metafields ? products[pi].metafields[row.key] : null;
        if (raw !== null && raw !== undefined && raw !== '') hasAny = true;
        values.push(raw);
      }
      if (!hasAny) continue; // no selected product has this spec — skip the row

      var tr = document.createElement('tr');
      var labelTd = document.createElement('td');
      labelTd.className = 'compare-table__row-label';
      labelTd.textContent = row.label || row.key;
      tr.appendChild(labelTd);

      for (var vi = 0; vi < values.length; vi++) {
        var valTd = document.createElement('td');
        valTd.className = 'compare-table__value';
        var val = values[vi];
        if (val !== null && val !== undefined && val !== '') {
          valTd.textContent = row.unit ? (val + ' ' + row.unit) : val;
        } else {
          valTd.textContent = '—';
        }
        tr.appendChild(valTd);
      }
      if (canAddMore) tr.appendChild(document.createElement('td'));

      tbody.appendChild(tr);
    }
    table.appendChild(tbody);
  }

  function initCompareTable() {
    var root = document.querySelector('[data-compare-root]');
    if (!root) return;

    var emptyEl = root.querySelector('[data-compare-empty]');
    var wrapEl = root.querySelector('[data-compare-table-wrap]');
    var promptEl = root.querySelector('[data-compare-add-another]');
    var table = root.querySelector('[data-compare-table]');
    var configEl = document.querySelector('[data-compare-row-config]');
    var browseUrl = root.getAttribute('data-compare-browse-url') || '/collections/all';

    // Let the shared remove/clear click handler ask this page to re-render.
    root._ptCompareReload = initCompareTable;

    var rowConfig = [];
    if (configEl) {
      try { rowConfig = JSON.parse(configEl.textContent) || []; } catch (e) { rowConfig = []; }
    }

    var items = compareRead();
    if (!items.length) {
      if (emptyEl) emptyEl.hidden = false;
      if (wrapEl) wrapEl.hidden = true;
      return;
    }

    // Only a confirmed 404 means the product is actually gone — anything
    // else (network blip, a slow/cold cache on the fetched section, a
    // non-JSON error page) is a transient failure and must NOT delete the
    // item from the tray. Silently pruning on any error meant a single
    // flaky request — most likely right after adding something, before
    // that URL had ever been fetched — could permanently wipe an item the
    // shopper had just picked, with no way to tell why it vanished.
    var fetches = items.map(function (item) {
      // item.url can already carry a query string — e.g. Shopify appends
      // its own _pos/_sid/_ss tracking params to product.url when a
      // product came from search results. Strip it before appending ours;
      // blindly concatenating a second "?" breaks the request (only the
      // first "?" starts a real query string, so "sections" never parses).
      var cleanUrl = item.url.split('?')[0].split('#')[0];
      var fetchUrl = cleanUrl + '?sections=compare-product-data';
      return fetch(fetchUrl)
        .then(function (res) {
          if (res.status === 404) return { gone: true };
          if (!res.ok) {
            console.error('[Compare] ' + res.status + ' fetching ' + fetchUrl);
            return { gone: false, product: null };
          }
          return res.json().then(function (json) {
            var html = json && json['compare-product-data'];
            if (!html) {
              console.error('[Compare] response missing "compare-product-data" section for ' + fetchUrl, json);
              return { gone: false, product: null };
            }
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var script = doc.querySelector('[data-compare-product-json]');
            if (!script) {
              console.error('[Compare] rendered section had no [data-compare-product-json] for ' + fetchUrl);
              return { gone: false, product: null };
            }
            try { return { gone: false, product: JSON.parse(script.textContent) }; }
            catch (e) {
              console.error('[Compare] could not parse product JSON for ' + fetchUrl, e);
              return { gone: false, product: null };
            }
          }, function (jsonErr) {
            console.error('[Compare] response for ' + fetchUrl + ' was not valid JSON — likely redirected to an HTML page', jsonErr);
            return { gone: false, product: null };
          });
        })
        .catch(function (err) {
          console.error('[Compare] network error fetching ' + fetchUrl, err);
          return { gone: false, product: null }; // don't delete on a network error — retry next load
        });
    });

    Promise.all(fetches).then(function (results) {
      var products = [];
      var staleHandles = [];
      var failedCount = 0;
      for (var i = 0; i < results.length; i++) {
        if (results[i] && results[i].product) { products.push(results[i].product); }
        else if (results[i] && results[i].gone) { staleHandles.push(items[i].handle); }
        else { failedCount++; } // transient failure — leave it in storage, just not shown this time
      }

      if (staleHandles.length) {
        var remaining = compareRead().filter(function (item) {
          return staleHandles.indexOf(item.handle) === -1;
        });
        compareWrite(remaining);
        compareRenderTray();
      }

      if (!products.length) {
        if (emptyEl) {
          emptyEl.hidden = false;
          if (failedCount && !staleHandles.length) {
            var msg = emptyEl.querySelector('p');
            if (msg) msg.textContent = "Couldn't load your selection — check your connection and refresh.";
          }
        }
        if (wrapEl) wrapEl.hidden = true;
        return;
      }

      compareBuildTable(products, rowConfig, table, promptEl, browseUrl);
      if (emptyEl) emptyEl.hidden = true;
      if (wrapEl) wrapEl.hidden = false;
    });
  }

  /* ---------- Header search ---------- */
  function initHeaderSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var panel = document.querySelector('[data-search-panel]');
    if (!toggle || !panel) return;
    var input = panel.querySelector('[data-search-input]');

    function open() {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      if (input) input.focus();
    }
    function close() {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      if (panel.classList.contains('is-open')) close(); else open();
    });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initHeroSlider() {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;
    var slides = slider.querySelectorAll('[data-hero-slide]');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    if (slides.length < 2) return;

    var current = 0;
    var speed = (parseInt(slider.getAttribute('data-speed'), 10) || 5) * 1000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
    }

    function start() {
      if (reduceMotion) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, speed);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-index'), 10) || 0);
        start(); // reset the timer after manual navigation
      });
    });

    // Prev/next arrows, left/right keys while the slider has focus, and
    // swipe on touch screens. Each resets the autoplay timer.
    function step(delta) { show(current + delta); start(); }
    var prevBtn = slider.querySelector('[data-hero-prev]');
    var nextBtn = slider.querySelector('[data-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });
    var touchX = null, touchY = null;
    slider.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX; touchY = e.touches[0].clientY;
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      touchX = touchY = null;
      // Mostly-horizontal swipe of 40px+ only, so vertical page scrolls don't flip slides.
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
    }, { passive: true });

    start();
  }

  /* ---------- Collection filter drawer ---------- */
  function initFilterDrawer() {
    var drawer = document.querySelector('[data-filter-drawer]');
    var toggle = document.querySelector('[data-filter-toggle]');
    if (!drawer || !toggle) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initToast();
    initQuote();
    initGallery();
    initImageZoom();
    initVariant();
    initQtyLimit();
    initRecommendations();
    initFilterDrawer();
    initHeroSlider();
    initHeaderSearch();
    initCompare();
    initCompareTable();
    initLeadTracking();
  });

  /* ---------- Lead tracking ---------- */
  // One entry point for every lead the theme itself can see. Publishes a
  // Shopify custom event ("patriot:lead") that a custom pixel in
  // Settings → Customer events forwards to Google Analytics as
  // generate_lead (see docs/customer-events-pixel.js), and also pushes to
  // window.dataLayer for any Google Tag Manager setup.
  // Shopify Forms submissions are NOT sent from here — the pixel picks
  // those up from Shopify's built-in form_submitted event, so they aren't
  // double counted. Never put names, emails or phone numbers in `details`.
  function trackLead(leadType, details) {
    var data = { lead_type: leadType, page_path: window.location.pathname };
    for (var k in details || {}) {
      if (Object.prototype.hasOwnProperty.call(details, k) && details[k] != null && details[k] !== '') data[k] = details[k];
    }
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('patriot:lead', data);
      }
    } catch (e) { /* analytics must never break the page */ }
    try {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: 'generate_lead' };
      for (var j in data) dl[j] = data[j];
      window.dataLayer.push(dl);
    } catch (e) {}
  }

  // Tapping the phone number is a lead too — most dealer leads still call.
  function initLeadTracking() {
    document.addEventListener('click', function (e) {
      var tel = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (!tel) return;
      var where = tel.closest('header') ? 'header' : (tel.closest('footer') ? 'footer' : 'page');
      trackLead('phone_click', { link_location: where });
    });
  }

  // expose for inline handlers / sections that need it
  window.PatriotToast = showToast;
  window.PatriotTrackLead = trackLead;
})();
